type LogoProps = {
  compact?: boolean
  locale?: 'fa' | 'en'
}

const artwork = '/images/brand/paye-tech-lockup.png'

function BrandCrop({ className }: { className: string }) {
  return (
    <span className={className} aria-hidden="true">
      <img src={artwork} alt="" width="2140" height="735" decoding="async" />
    </span>
  )
}

export function PayeMark() {
  return <BrandCrop className="brand__mark" />
}

export function PersianWordmark() {
  return <BrandCrop className="brand__wordmark brand__wordmark--fa" />
}

export function EnglishWordmark() {
  return <BrandCrop className="brand__wordmark brand__wordmark--en" />
}

export function Logo({ compact = false, locale = 'fa' }: LogoProps) {
  return (
    <span
      className={`brand${compact ? ' brand--compact' : ''}`}
      role="img"
      aria-label={locale === 'fa' ? 'پایه‌تک' : 'Paye Tech'}
    >
      <PayeMark />
      {!compact && (locale === 'fa' ? <PersianWordmark /> : <EnglishWordmark />)}
    </span>
  )
}
